/** Purchased physical supply is distinct from prescribed dose/frequency. */
export function PrescriptionSupply({
  summary,
  review = false,
}: {
  summary?: string | null;
  review?: boolean;
}) {
  if (!summary) return null;
  return (
    <div className="border border-line-subtle bg-sunken p-10 mt-6">
      <p className="type-label-xs text-ink-muted">Purchased supply</p>
      <p className="type-body-sm text-ink font-medium mt-3">{summary}</p>
      {review && (
        <p className="text-11 text-ink-muted mt-4">
          Supply quantity is not an injection dose. Review dose, frequency, and
          supplies before prescribing.
        </p>
      )}
    </div>
  );
}
